import {analyticsManager} from "../analytics-utils";

class MultiSelect {
    constructor() {
        this.multiselect = document.getElementById('multiselect');
        this.selectedDisplay = this.multiselect.querySelector('.selected-display');
        this.selectedText = this.multiselect.querySelector('.selected-text');
        this.dropdownOptions = this.multiselect.querySelector('.dropdown-options');
        this.allOptions = this.multiselect.querySelectorAll('div[data-type="option"]');
        this.selectedItemsDisplay = document.getElementById('selected-items-display');
        this.hiddenInput = document.getElementById('selected-pages');
        this.hiddenNames = document.getElementById('selected-pages-name');

     
        this.formPage = document.getElementById('form-page');
        this.feedbackDiv = this.formPage.querySelector('.feedback');
        this.contactForm = this.formPage.querySelector('form[data-id="contact-form"]');
        this.formType = this.contactForm.dataset.formType;
        this.thankYouPage = document.getElementById('thank-you-page');
        this.selectedPagesInfo = document.getElementById('selected-pages-info');
        this.backButton = document.getElementById('back-button');
        
        this.selectPlaceholder =  this.contactForm.dataset.placeholder;
        this.chosenText = this.contactForm.dataset.chosentext;
        this.extendedFieldsEnabled = this.contactForm.dataset.extendedFields === 'true';
        
        this.selectedIds = [];
        
        this.setupEventListeners();
        
    }
    
    setupEventListeners() {
        this.contactForm.addEventListener('submit', async (e) => {
            e.preventDefault();
            await this.handleSubmit(e);
        });

        this.selectedDisplay.addEventListener('click', () => {
            this.multiselect.classList.toggle('dropdown-open');
        });

        document.addEventListener('click', (e) => {
            if (!this.multiselect.contains(e.target)) {
                this.multiselect.classList.remove('dropdown-open');
            }
        });
        
        this.allOptions.forEach(option => {
            option.addEventListener('click', () => this.toggleOption(option));
        });



        this.backButton?.addEventListener('click', () => {
            this.formPage.style.display = 'block';
            this.thankYouPage.style.display = 'none';
        });
    }


    async handleSubmit(e) {
        this.clearValidationMessages();

        try {
            const formDataRaw = new FormData(this.contactForm);
            
            const response = await fetch(this.contactForm.action, {
                method: 'POST',
                body: formDataRaw,
                headers: {
                    'RequestVerificationToken': document.querySelector('input[name="__RequestVerificationToken"]').value
                }
            });

            const result = await response.json();
            

            if (!response.ok) {
                this.handleValidationErrors(result);
            } else {
                this.handleSuccess(result);
            }
        } catch (error) {
            this.showFeedback(
                this.contactForm.dataset.errorMessage || 'An error occurred while processing your request. Please try again later.',
                false
            );
        } finally {
            // this.setLoadingState(false);
        }
    }

    handleSuccess(result) {
        if (result.Success) {
            this.contactForm.reset();
            this.showFeedback(result.Message, true);

            // Execute form-specific callback if it exists
            if (this.formType) {
                analyticsManager.trackFormSubmission(this.formType, result.FormData, '');
            }

            this.showThankYouPage();
        } else {
            this.showFeedback(result.Message, false);
        }
    }
    
    showThankYouPage() {
        this.formPage.style.display = 'none';
        this.thankYouPage.style.display = 'block';

        const selectedPagesInfoChildren = Array.from(this.selectedPagesInfo.children);
        selectedPagesInfoChildren.forEach(child => {
            if (this.selectedIds.includes(child.dataset.epiId)) {
                child.classList.remove('!hidden');
            }
        });
    }

    toggleOption(option) {
        option.classList.toggle('option-selected');
        const checkbox = option.querySelector('div[data-type="checkbox"]');
        checkbox.classList.toggle('flex');
        checkbox.classList.toggle('hidden');
        this.updateSelectedPages();
    }

    updateSelectedPages() {
        const selectedOptions = Array.from(this.dropdownOptions.querySelectorAll('.option-selected'));
        const selectedIds = selectedOptions.map(opt => opt.dataset.id);
        const selectedNames = selectedOptions.map(opt => opt.dataset.name);

        this.hiddenInput.value = JSON.stringify(selectedIds);
        this.hiddenNames.value = JSON.stringify(selectedNames);
        
        this.selectedIds = selectedIds;

        this.selectedText.textContent = selectedOptions.length
            ? `${selectedOptions.length} ${this.chosenText}`
            : this.selectPlaceholder;

        this.selectedItemsDisplay.innerHTML = '';
        selectedOptions.forEach(opt => {
            const pill = document.createElement('div');
            pill.className = 'bg-blue-100 text-blue-800 text-sm px-2 py-1 rounded-full flex items-center';
            pill.innerHTML = `
                    <button type="button" class="btn btn-icon btn-tertiary btn-small" data-id="${opt.dataset.id}">
                        <span class="content">${opt.dataset.name}</span>
                        <span class="icon icon-close"></span>
                    </button>
                `;

            pill.querySelector('button').addEventListener('click', (e) => {
                const optionToDeselect = this.dropdownOptions.querySelector(`[data-id="${e.currentTarget.dataset.id}"]`);
                this.toggleOption(optionToDeselect);
            });

            this.selectedItemsDisplay.appendChild(pill);
        });
    }

    clearValidationMessages() {
        this.contactForm.querySelectorAll('.validation-failed').forEach(div => {
            div.style.display = 'none';
        });
        this.feedbackDiv.style.display = 'none';
    }

    showFeedback(message, isSuccess) {
        const content = this.feedbackDiv.querySelector('.content');
        if (content) {
            content.textContent = message;
        }

        const icon = this.feedbackDiv.querySelector('.icon');

        if (isSuccess) {
            icon.classList.remove('text-red-800');
            icon.classList.remove("icon-close");
            icon.classList.add("icon-checkmark");
        } else {
            icon.classList.add('text-red-800');
            icon.classList.add("icon-close");
            icon.classList.remove("icon-checkmark");
        }

        this.feedbackDiv.classList.toggle('bg-foreground-light', isSuccess);
        this.feedbackDiv.classList.toggle('bg-red-800', !isSuccess);
        this.feedbackDiv.style.display = 'flex';
    }

    handleValidationErrors(result) {
        if (result.Errors && result.Errors.length > 0) {
            result.Errors.forEach(error => {
                const fieldName = error.MemberNames?.[0]?.toLowerCase() || '';
                const input = this.contactForm.querySelector(`[name="${fieldName}"i]`);
                if (input) {
                    const errorDiv = input.closest('.form-group')?.querySelector('.validation-failed');
                    if (errorDiv) {
                        errorDiv.textContent = error.ErrorMessage;
                        errorDiv.style.display = 'block';
                    }
                }
            });
        }

        if (result.message) {
            this.showFeedback(result.message, false);
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    new MultiSelect();
});